export default __webpack_public_path__ + "static/media/95ba3828c2d22154c5de583ddc5b3c74.9ed99a9f.svg";